import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DirectorySearch } from '../components/DirectorySearch/DirectorySearch';
import { theme } from 'antd';
import { useBands } from '../api/queries';
import { BandListing } from '../components/DirectoryListings/BandListing/BandListing';
import { useHeader } from '../components/Layout/MainLayout';

function Bands() {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { data: bands, isLoading, error } = useBands();
  const { searchQuery } = useHeader();
  const q = searchQuery.toLowerCase();

  const handleBandClick = (bandId: string) => {
    navigate(`/bands/${bandId}`);
  };

  return (
    <div className="directory-page">
      <div className="directory-page__tabs">
        <DirectorySearch activeTab="bands" />
      </div>
      <div className="body-temp directory-page__list">
        {isLoading && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
            Loading bands...
          </div>
        )}

        {error && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorError }}>
            Error loading bands: {error.message}
          </div>
        )}

        {bands && bands.length > 0 && (() => {
          const filteredBands = q
            ? bands.filter(band => band.name.toLowerCase().includes(q))
            : bands;
          return filteredBands.length > 0 ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}>
              {filteredBands.map((band) => (
                <BandListing
                  key={band.id}
                  name={band.name}
                  imageUrl={band.photo_url}
                  soundcloudUrl={band.soundcloud_url}
                  onClick={() => handleBandClick(band.id)}
                />
              ))}
            </div>
          ) : (
            <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
              No bands found.
            </div>
          );
        })()}

        {bands && bands.length === 0 && !q && (
          <div style={{ fontSize: token.fontSizeSM, lineHeight: token.lineHeightSM, color: token.colorTextSecondary }}>
            No bands found.
          </div>
        )}
      </div>
    </div>
  );
}

export default Bands;
